<template>
  <section class="reviews">
    <div class="container container--mw-xxl reviews__container">
      <div class="row m-0 reviews__row">
        <div class="col p-0 reviews__column">
          <ReviewBlock :copy="'Happy Customer Testimonials coming soon!'" />
        </div>

        <div class="col p-0 reviews__column">
          <ReviewBlock :copy="'Happy Customer Testimonials coming soon!'" />
        </div>

        <div class="col p-0 reviews__column">
          <ReviewBlock :copy="'Happy Customer Testimonials coming soon!'" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ReviewBlock from "@/views/HomePage/ReviewBlock";

export default {
  name: "ReviewsSection",
  components: {
    ReviewBlock,
  },
};
</script>
